import { useContext } from 'react';

import { ExternalShareContext } from '@confluence/external-share-context/entry-points/ExternalShareContext.ts';
import { expValEquals } from '@confluence/feature-experiments';

/**
 * Whether the current request is an access-link request for which the
 * `access_link_m2` experiment is enabled.
 *
 * Use this to skip requests that are meaningless for access-link viewers
 * (e.g. edition-awareness, billing, trial, and create-permission queries)
 * while leaving all other routes and public share-link viewers unaffected.
 */
export const useIsAccessLinkRequest = (): boolean => {
	const { isAccessLinkRequest } = useContext(ExternalShareContext);

	// The experiment is evaluated inline and last (no-preconditioning) so it is
	// only reached for genuine access-link viewers.
	return isAccessLinkRequest && expValEquals('access_link_m2', 'isEnabled', true);
};
